module.exports = __webpack_public_path__ + "img/64.a3b2c95f.png";